module.exports = {
  "home": {
    xlzx: "心理咨询",
    xlcp: "心理测评",
    xlkt: "心理课堂",
    xlrx: "心理热线",
    xlInformation: "心理资讯",
    xlInformationHint: "和伙伴分享你的</br>故事吧~",
    xlhd: "心理活动",
    xlhdHint: "一起活动8~",
    evaluationReminder: "测评</br>提醒",
    ljcp: "立即测评",
    cpjl: "测评记录",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/home/en.js